var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"badge-minimal",attrs:{"width":"80","src":require('@/assets/images/logo/logo-dark.png')}})}
var staticRenderFns = []

export { render, staticRenderFns }